import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';

import { FC, Fragment } from 'react';

import { Layout } from '../UI/Layout';

import { IBreadCrumbsProps } from './types';

import * as styles from './styles.css';

export const BreadCrumbs: FC<IBreadCrumbsProps> = props => {
  const { breadCrumbs } = props;

  if (!breadCrumbs.length) {
    return null;
  }

  return (
    <Layout filled={false}>
      <div aria-label="Ссылки на поиск по коворкингам" className={styles['container']}>
        {breadCrumbs.map((crumb, index) => {
          const url = crumb.url || '/';
          const title = crumb.text || 'Ссылка';

          return (
            <Fragment key={`${title}`}>
              {index === 0 ? null : (
                <span className={styles['arrow']}>
                  <IconActionChevronRightSmall16 color="gray60_100" />
                </span>
              )}
              <a className={styles['crumb']} href={url} title={title}>
                <ArticleParagraph2 color="gray60_100">{title}</ArticleParagraph2>
              </a>
            </Fragment>
          );
        })}
      </div>
    </Layout>
  );
};

BreadCrumbs.displayName = 'BreadCrumbs';
